module.exports = __webpack_public_path__ + "static/img/8.7dbc352.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/20/eng/8.png
// module id = GYhH
// module chunks = 0